export const symbolsImages: string[] =
  ['./assets/images/pattern/square_blue.png',
    './assets/images/pattern/square_red.png',
    './assets/images/pattern/square_green.png',
    './assets/images/pattern/square_yellow.png',
    './assets/images/pattern/circle_blue.png',
    './assets/images/pattern/circle_red.png',
    './assets/images/pattern/circle_green.png',
    './assets/images/pattern/circle_yellow.png',
    './assets/images/pattern/triangle_blue.png',
    './assets/images/pattern/triangle_red.png',
    './assets/images/pattern/triangle_green.png',
    './assets/images/pattern/triangle_yellow.png',
    './assets/images/pattern/star_blue.png',
    './assets/images/pattern/star_red.png',
    './assets/images/pattern/star_green.png',
    './assets/images/pattern/star_yellow.png'] ;
